'use client';

import './PageSideNav.css';

import { SideNavSection } from '../../types';
import { HomepageSideNavLink } from './HomepageSideNavLink';
import { useActiveHomepageSideNavSection } from './useActiveHomepageSideNavSection';
import { getHomepageSideNavSectionId } from './utils';
type PageSideNavProps = {
  sections: SideNavSection[];
};

export function PageSideNav({ sections }: PageSideNavProps) {
  const { activeTag, selectSection } =
    useActiveHomepageSideNavSection(sections);

  return (
    <nav
      aria-label='Page sections'
      className='headerLg:sticky BentoSidenav flex flex-col gap-y-3 py-15 pl-11 pr-4'
    >
      {sections.map((section) => (
        <HomepageSideNavLink
          key={getHomepageSideNavSectionId(section)}
          section={section}
          isActive={activeTag === section.tag}
          onSelect={selectSection}
        />
      ))}
    </nav>
  );
}
